<script setup lang="ts">
import { __ } from '@@/bits/intl'
import { useWindowSizeStore } from '@@/pinia/window_size'
import LocaleSelector from '@@/vuecomponents/LocaleSelector.vue'
import { storeToRefs } from 'pinia'

const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletPortrait, isBiggerThanTabletLandscape } = storeToRefs(windowSizeStore)
</script>

<template>
  <footer :class="{ 'mobile-view': isSmallerThanTabletPortrait, 'portrait-view': !isBiggerThanTabletLandscape }">
    <div class="nav-container">
      <nav :aria-label="__('Footer')">
        <div class="row">
          <strong>{{ __('Product') }}</strong>
          <div class="row-items">
            <a href="https://padlet.com/site/product" target="_blank">{{ __('Features,') }}</a>
            <a href="https://padlet.com/about/apps" target="_blank">{{ __('Apps and Plugins,') }}</a>
            <a href="https://padlet.blog" target="_blank">{{ __("What's new") }}</a>
          </div>
        </div>
        <div class="row">
          <strong>{{ __('Memberships') }}</strong>
          <div class="row-items">
            <a href="https://padlet.com/memberships" target="_blank">{{ __('All,') }}</a>
            <a href="https://padlet.com/memberships" target="_blank">{{ __('Personal,') }}</a>
            <a href="https://padlet.com/memberships" target="_blank">{{ __('School,') }}</a>
            <a href="https://padlet.com/memberships" target="_blank">{{ __('Team') }}</a>
          </div>
        </div>
        <div class="row">
          <strong>{{ __('Support') }}</strong>
          <div class="row-items">
            <a href="https://padlet.help" target="_blank">{{ __('Knowledge Base,') }}</a>
            <a href="https://www.youtube.com/padlet" target="_blank">{{ __('Video Tutorials,') }}</a>
            <a href="https://padlet.com/gallery" target="_blank">{{ __('Examples,') }}</a>
            <a href="https://twitter.com/padlet" target="_blank">{{ __('Twitter') }}</a>
          </div>
        </div>
        <div class="row">
          <strong>{{ __('Company') }}</strong>
          <div class="row-items">
            <a href="https://padlet.jobs" target="_blank">{{ __('About Us,') }}</a>
            <a href="https://padlet.jobs/open-roles" target="_blank">{{ __('Careers') }}</a>
          </div>
        </div>
        <div class="row">
          <strong>{{ __('Legal') }}</strong>
          <div class="row-items">
            <a href="https://padlet.com/about/terms" target="_blank">{{ __('Terms of Use,') }}</a>
            <a href="https://padlet.com/about/privacy" target="_blank">{{ __('Privacy Policy,') }}</a>
            <a href="https://padlet.com/about/content" target="_blank">{{ __('Content Policy,') }}</a>
            <a href="https://padlet.com/about/accessibility" target="_blank">{{ __('Accessibility') }}</a>
          </div>
        </div>
        <div class="beautiful-message">{{ __("Oh wow, you're so beautiful. Just saying.") }}</div>
        <LocaleSelector />
      </nav>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  font-size: 16px;
  max-width: 836px;
  min-width: 630px;
  margin: 120px auto 0px auto;
  width: 60%;

  nav {
    max-width: 1080px;
    margin: 0px auto;

    select {
      width: max-content;
      padding-left: 0px;
      padding-right: 30px;
    }
  }

  .nav-container {
    height: 480px;
  }
}
.row {
  line-height: 2.7rem;
  display: flex;

  a {
    text-decoration: none;
    color: var(--body-text-color);
    margin: 0 0.5em;
  }

  strong {
    margin: 0;
    margin-right: 0.9em;
  }
}

.beautiful-message {
  margin: 2em 0;
  font-size: 0.75em;
  text-transform: uppercase;
  letter-spacing: 0.3em;
  color: var(--muted-text-color);
}

.portrait-view {
  box-sizing: border-box;
  margin: 14px 0px;
  padding: 0 14px;
  min-width: unset;
  width: 100%;
}

.mobile-view {
  margin-top: 15px;

  .nav-container {
    height: 750px;
  }

  nav {
    padding-left: 0px;
    padding-right: 0px;
  }

  .row {
    flex-direction: column;
    line-height: 32px;

    .row-items {
      display: flex;
      flex-wrap: wrap;
    }
  }

  strong {
    font-weight: 600;
    font-size: 14px;
    margin: 0px;
    margin-right: 10px;
  }

  a {
    font-size: 14px;
    font-weight: 300;
    margin: 0px;
    margin-right: 10px;
    white-space: nowrap;
    color: var(--body-text-color);
  }

  .beautiful-message {
    line-height: 26px;
    letter-spacing: 1.1px;
  }
}

.beautiful-message:hover {
  animation: rainbow 1s infinite;
}

@keyframes rainbow {
  0% {
    color: #f05ea7;
  }
  10% {
    color: #ff0000;
  }
  20% {
    color: #ff8000;
  }
  40% {
    color: #07c107;
  }
  50% {
    color: #3fc280;
  }
  70% {
    color: #3b92eac4;
  }
  80% {
    color: #6f6fed;
  }
  90% {
    color: #8000ffbd;
  }
  100% {
    color: #f71988;
  }
}
</style>
